export default __webpack_public_path__ + "fr/static/media/4etoiles.207d8914.svg";